<script setup>
const props = defineProps({
  emptyMessage: {
    type: String,
    default: undefined,
  },
});

const { t } = useI18n();

const message = computed(() => props.emptyMessage || t('states.nothingFound'));
</script>

<template>
  <div class="ui-empty-state">
    <div class="ui-empty-state__font">{{ message }}</div>
  </div>
</template>

<style scoped lang="scss">
.ui-empty-state {
  text-align: center;

  &__font {
    font-size: em(32);
    line-height: em(35, 32);

    @include media-breakpoint-down(sm) {
      font-size: em(20);
      line-height: em(22, 20);
    }
  }
}
</style>
